import { observer } from 'mobx-react';
import React from 'react';
import { BUTTON_TITLE, DEBOUNCE_TIME } from 'src/constants/main';
import { SCREENS } from 'src/constants/screens';
import { localeStore } from 'src/mobx/localesStore';
import { history } from 'src/services/history';
import { LoadingStatus } from 'src/types/main';
import SearchInput from 'src/view/components/Controls/SearchInput/SearchInput';
import CountriesList from 'src/view/screens/SettingsScreen/screens/General/LanguageCountryCurrency/containers/CountriesList/CountriesList';
import countriesStore from 'src/view/screens/SettingsScreen/store/countriesStore';
import Button from '~/view/components/Controls/ButtonComponent/Button';

const Country: React.FC = observer((): JSX.Element => {
  const createCountry = () => {
    history.push(SCREENS.SETTINGS_COUNTRY_CREATE());
  };
  return (
    <div className="d-flex flex-column full-width flex-grow-1 mt-4">
      <div className="pl-2 d-flex flex-row mr-4 justify-content-between">
        <div className="d-flex flex-row justify-content-start">
          <SearchInput
            value={countriesStore.filters.search || ''}
            onChangeText={(phrase: string) => countriesStore.setFilters({ search: phrase })}
            loading={countriesStore.countriesLoadingStatus === LoadingStatus.Loading}
            debounceDelay={DEBOUNCE_TIME.MEDIUM}
            withResetIcon
            customPlaceholder
            placeholder="txt_search"
            className="menu-manag-tab-header__search mr-2"
            inputClassName="color-dark text-size-16 family-medium"
          />
        </div>
        <Button title={localeStore.t(BUTTON_TITLE.CREATE)} onClick={createCountry} />
      </div>
      <CountriesList />
    </div>
  );
});

export default Country;
